module.exports = __webpack_public_path__ + "img/posterSearch-des8.e6f1116e.png";